function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

import { groupRows } from "./groupRows";
import { sortRows } from "./sortRows";
export function getDataState(_ref, sorting) {
  var columns = _ref.columns,
      data = _ref.data,
      grouping = _ref.grouping;
  var d = {
    grouped: false,
    rows: data
  };
  var sortFn;

  if (sorting) {
    var sortingColumn = columns.find(function (column) {
      return column.key === sorting.key;
    });

    if (sortingColumn) {
      sortFn = function sortFn(rows) {
        return sortRows(rows, sorting, sortingColumn.comparator);
      };
    }
  }

  if (grouping) {
    d.grouped = true;
    d.rows = groupRows(data, grouping);
  }

  if (d.grouped) {
    d.rows = d.rows.map(function (_ref2) {
      var _ref3 = _slicedToArray(_ref2, 2),
          key = _ref3[0],
          rows = _ref3[1];

      return [key, sortFn ? sortFn(rows) : rows];
    });
  } else {
    d.rows = sortFn ? sortFn(d.rows) : d.rows;
  }

  return d;
}